import { render, staticRenderFns } from "./adManage.vue?vue&type=template&id=20e07342"
import script from "./adManage.vue?vue&type=script&lang=js"
export * from "./adManage.vue?vue&type=script&lang=js"
import style0 from "./adManage.vue?vue&type=style&index=0&id=20e07342&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports